/* Model */
import HOSSectionRules from 'live/views/Configuration/Greenmile.Configuration.HOSSectionRules.js'

class ConfigurationModel extends App.Models.BaseModel {
    modelUrl = 'Configuration';
}

App.Models.Configuration = ConfigurationModel;

/* Collection */
class ConfigurationCollection extends App.Collections.BaseCollection {
    url = 'Configuration';
    model = App.Models.Configuration;
}

App.Collections.Configurations = ConfigurationCollection;

/* Router */
class ConfigurationRouter extends App.Routers.BaseRouter {
    constructor() {
        const entityName = 'Configuration';
        const model = App.Models.Configuration;
        const collectionClass = App.Collections.Configurations;

        super(entityName, model, collectionClass);
    }

    afterCreateForm = () => {
        const inputSelector_distance = "#Configuration #Configuration_distanceMetersToGetPosition label";
        const inputSelector_accuracy = "#Configuration #Configuration_accuracyMetersToIgnorePosition label";
        const inputSelector_locationVisitRadius = "#Configuration #Configuration_locationsVisitRadiusMeters label";
        const inputSelector_suggest = "#Configuration #Configuration_suggestLocationsWithinRadius label";
        const inputSelector_minutesSuggest = "#Configuration #Configuration_minutesToSuggestStop label";

        Monet.FormBuilder.appendUnitySystemMetersOrFeet(inputSelector_distance);
        Monet.FormBuilder.appendUnitySystemMetersOrFeet(inputSelector_accuracy);
        Monet.FormBuilder.appendUnitySystemMetersOrMiles(inputSelector_locationVisitRadius);
        Monet.FormBuilder.appendUnitySystemMetersOrMiles(inputSelector_suggest);
        Monet.FormBuilder.appendUnitySystemMinutes(inputSelector_minutesSuggest);

        new HOSSectionRules().addListeners();
        this.checkTicketSupportSection();
    };

    afterPopulateForm = () => {
        new HOSSectionRules().checkToEnableLookups();
    };

    beforeValidate = () => {
        const form = App.Forms[this.entityName].form;
        const fields = form.fields;

        if (!fields.finishHosOnCompleteRoute) {
            fields.finishHosOnCompleteRoute = new Monet.UI.Fields.Checkbox();
        }

        fields.finishHosOnCompleteRoute.setValue(fields.startHosOnStartRoute.getValue());

        new HOSSectionRules().checkIfLookupsAreMandatorys();
    };

    checkTicketSupportSection = () => { 
        const featureTogglesState = GreenmileReduxStore?.getState()?.configuration?.featureStates;
        const toggleTicketSupport = featureTogglesState?.get?.('ENABLE_TICKET_SUPPORT');

        if (!toggleTicketSupport?.enabled) {
            const ticketSupportSectionEl = document.querySelector('[key*="enable_ticket_support_configuration"]');
            ticketSupportSectionEl?.parentNode?.removeChild?.(ticketSupportSectionEl);
        }
    }
}

App.Routers.Configuration = ConfigurationRouter;
